export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '标签', dataIndex: 'tagName', width: 200},
    {title: '创建人', dataIndex: 'createdByName', width: 100},
    {title: '操作', dataIndex: 'action', width: 200, render: 'actionRender'},
  ],
  search: [
    {label: '标签', name: 'tagName'},
  ],
  footer: [
    {label: '新增', type: 'primary', events: ['onClick:onAdd']}
  ]
}
